<div class="tabcontent p-0">
  <fieldset class="contenttabstyle">
    <div class="row no_row_margin">
      <div class="col-12">
        @if (showTitle) {
          <h2 class="tabcontentTitle">{{ title }}</h2>
        }
        <div class="tabcontent tabWizGridInside">
          <asap-grid-layout
            [data]="data"
            [pagingEnabled]="false"
            [enableSiteSelection]="false"
            [isData]="true"
            class="gridWithcontent"
            >
            <ng-template pageListColumn name="Asset #" field="assetNumber" let-item>
              {{ item.assetNumber }}
            </ng-template>
            <ng-template pageListColumn name="Asset Name" field="name" let-item>
              {{ item.assetName || item.name }}
            </ng-template>
            <ng-template pageListColumn name="Site" field="site" let-item>
              {{ item.site?.code || item.site?.name || item.siteName || item.siteCode }}
            </ng-template>
            <ng-template pageListColumn name="Location" field="location" let-item>
              {{ item.location?.code || item.location?.name || item.locationName || item.locationCode }}
            </ng-template>
            @if (!isReadOnly; as item) {
              <ng-template class="asap-grid-remove" pageListColumn name="command" let-item>
                <div class="asap-grid-remove" (click)="onClear(item)">
                  <div class="asap-grid-remove-icon">
                    <img src="/assets/menu/enterprise/remove-icon.svg" />
                  </div>
                  <div class="asap-grid-remove-text mt-1">Delete</div>
                </div>
              </ng-template>
            }
          </asap-grid-layout>
        </div>
      </div>
    </div>
  </fieldset>
</div>
